import http from '../http'
import url from './index-url'
import qs from 'qs'
const { get, post } = http

export default {
  getPermission() {
    return get(url.getPermission())
  },
  getLogininfo() {
    return get(url.getLogininfo())
  },
  logout(data) {
    return post(url.logout(), qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }
}